module.exports = __webpack_public_path__ + "assets/img/0801.b97dabf7.svg";